import { render, staticRenderFns } from "./ActiveCard.vue?vue&type=template&id=6bc02896"
import script from "./ActiveCard.vue?vue&type=script&lang=js"
export * from "./ActiveCard.vue?vue&type=script&lang=js"
import style0 from "./ActiveCard.vue?vue&type=style&index=0&id=6bc02896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports